// Vendor
import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
// Actions
import { selectClient } from 'IntegrationsApp/ts/features/integrations-shared/state/hartford-import-holdings/actions';
// Selectors
import { INTEGRATIONS_STATE_SLICE_KEY } from 'IntegrationsApp/ts/features/integrations-shared/state/integrations-shared.reducer';
import { getSelectedClient } from 'IntegrationsApp/ts/features/integrations-shared/state/hartford-import-holdings/import-holdings.selectors';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../../ycharts/static/ts/features/components/pagination/simple-pagination-controls/simple-pagination-controls.component";
const _c0 = a0 => ({ "selected": a0 });
const _c1 = a0 => ({ "text-default": a0 });
function HartfordClientListResultsComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 11);
    i0.ɵɵlistener("click", function HartfordClientListResultsComponent_div_21_Template_div_click_1_listener() { const client_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectClient(client_r2)); });
    i0.ɵɵelement(2, "span", 12)(3, "span", 13)(4, "span", 13)(5, "span", 14)(6, "span", 14)(7, "span", 14)(8, "span", 14);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const client_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0, ctx_r2.isClientSelected(client_r2.Id)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c1, !ctx_r2.isClientSelected(client_r2.Id)))("innerText", client_r2.Name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerText", client_r2.Firm || "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerText", client_r2.Territory || "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerText", client_r2.City || "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerText", client_r2.State || "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerText", client_r2.Type || "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerText", client_r2.HadModels ? "Yes" : "No");
} }
export class HartfordClientListResultsComponent {
    constructor(store) {
        this.store = store;
        this.pageChangeHandler = new EventEmitter();
        this.mapStateToComponent = (state) => {
            this.selectedClient = getSelectedClient(state);
        };
        this.storeSubscription = this.store.select(INTEGRATIONS_STATE_SLICE_KEY).subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    pageChanged(newPageNum) {
        this.paginationInfo.current_page_num = newPageNum;
        this.pageChangeHandler.emit(newPageNum);
    }
    selectClient(client) {
        if (this.isClientSelected(client.Id)) {
            this.store.dispatch(selectClient({ selectedClient: null }));
        }
        else {
            this.store.dispatch(selectClient({ selectedClient: client }));
        }
    }
    isClientSelected(clientId) {
        return this.selectedClient?.Id === clientId;
    }
    trackByClientId(index, client) {
        return client.Id;
    }
}
HartfordClientListResultsComponent.ɵfac = function HartfordClientListResultsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HartfordClientListResultsComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
HartfordClientListResultsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HartfordClientListResultsComponent, selectors: [["ycn-hartford-client-list-results"]], inputs: { serializedClients: "serializedClients", paginationInfo: "paginationInfo" }, outputs: { pageChangeHandler: "pageChangeHandler" }, standalone: false, decls: 22, vars: 3, consts: [[1, "container", "d-flex", "justify-content-end", "mt-1", "mb-1"], [1, "panel-pagination"], [1, "panel-pagination-content", 3, "pageChangeHandler", "paginationInfo"], [2, "overflow-x", "auto"], [1, "linked-list", 2, "min-width", "700px"], [1, "linked-list-header"], [2, "flex", "2"], [2, "flex", "1"], [1, "linked-list-body"], ["class", "linked-list-item", 3, "ngClass", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "linked-list-item", 3, "ngClass"], [1, "linked-list-item-header", 3, "click"], [2, "flex", "2", 3, "ngClass", "innerText"], [1, "text-muted", 2, "flex", "2", 3, "innerText"], [1, "text-muted", 2, "flex", "1", 3, "innerText"]], template: function HartfordClientListResultsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "ycn-simple-pagination-controls", 2);
        i0.ɵɵlistener("pageChangeHandler", function HartfordClientListResultsComponent_Template_ycn_simple_pagination_controls_pageChangeHandler_2_listener($event) { return ctx.pageChanged($event); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "span", 6);
        i0.ɵɵtext(7, "Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "span", 6);
        i0.ɵɵtext(9, "Firm");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "span", 6);
        i0.ɵɵtext(11, "Territory");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "span", 7);
        i0.ɵɵtext(13, "City");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "span", 7);
        i0.ɵɵtext(15, "State");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "span", 7);
        i0.ɵɵtext(17, "Type");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "span", 7);
        i0.ɵɵtext(19, "Had Models");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(20, "div", 8);
        i0.ɵɵtemplate(21, HartfordClientListResultsComponent_div_21_Template, 9, 13, "div", 9);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("paginationInfo", ctx.paginationInfo);
        i0.ɵɵadvance(19);
        i0.ɵɵproperty("ngForOf", ctx.serializedClients)("ngForTrackBy", ctx.trackByClientId);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i3.SimplePaginationControlsComponent], encapsulation: 2 });
